import { render, staticRenderFns } from "./artifact-card.vue?vue&type=template&id=7bccbdf3&scoped=true"
import script from "./artifact-card.vue?vue&type=script&lang=js"
export * from "./artifact-card.vue?vue&type=script&lang=js"
import style0 from "./artifact-card.vue?vue&type=style&index=0&id=7bccbdf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bccbdf3",
  null
  
)

export default component.exports